(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentDeleteController',VpPaymentDeleteController);

    VpPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'VpPayment'];

    function VpPaymentDeleteController($uibModalInstance, entity, VpPayment) {
        var vm = this;

        vm.vpPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VpPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
